import React from "react";
import styled from "styled-components";
import { compassLightGreen } from "../../styles";

// Styled container for the checkbox and label
const CheckboxContainer = styled.div<{ size?: number }>`
  display: flex;
  align-items: center;
  height: ${({ size }): string => (size ? `${size}px` : "25px")};
  width: ${({ size }): string => (size ? `${size}px` : "25px")};
  min-width: ${({ size }): string => (size ? `${size}px` : "25px")};
  min-height: ${({ size }): string => (size ? `${size}px` : "25px")};
  margin-right: 10px;
`;

// Hidden checkbox input
const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

// Styled checkbox (visible)
const StyledCheckbox = styled.div<{ checked: boolean; size?: number }>`
  display: inline-block;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  transition: all 100ms;
  border: 1px solid
    ${({ checked }): string => (checked ? compassLightGreen : "black")};
  cursor: pointer;
  position: relative;
  svg {
    visibility: ${({ checked }): string => (checked ? "visible" : "hidden")};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%; // Make the SVG smaller than the checkbox
    height: 90%;
  }
`;

const Icon = styled.svg`
  fill: none;
  stroke: ${compassLightGreen};
  stroke-width: 2px;
`;

export const Checkbox = ({
  className,
  checked,
  size,
  ...props
}: CheckboxProps): JSX.Element => {
  return (
    <CheckboxContainer className={className} size={size}>
      <HiddenCheckbox checked={checked} {...props} />
      <StyledCheckbox checked={checked} size={size}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
    </CheckboxContainer>
  );
};

// Custom Checkbox functional component
type CheckboxProps = {
  checked: boolean;
  size?: number;
  className?: string;
  onChange?: () => void;
};
